import React from 'react'
import { PERMISSIONS } from '../auth/constants'

import { Redirect } from 'react-router'
import { usePermissions, useLogout } from '../auth/hooks'

const Landing = () => {
  const [
    commandCentral,
    roadClosures,
    sigEvents,
    sitRep,
    admin,
  ] = usePermissions([
    PERMISSIONS.IRISS_ACCESS,
    PERMISSIONS.ROAD_CLOSURES_VIEW,
    PERMISSIONS.SIGNIFICANT_EVENTS_VIEW,
    PERMISSIONS.SITREP_VIEW,
    PERMISSIONS.ADMIN,
  ])
  const logout = useLogout()

  if (commandCentral) {
    return <Redirect to="/commandCentral" />
  } else if (roadClosures) {
    return <Redirect to="/roadClosures" />
  } else if (sigEvents) {
    return <Redirect to="/sigEvents" />
  } else if (sitRep) {
    return <Redirect to="/sitRep" />
  } else if (admin) {
    return <Redirect to="/admin" />
  } else {
    logout()
  }

  return null
}

export default Landing
